export const PATH_LABELS = {
  entrar: 'Entrar',
  pagina_inicial: 'Página Inicial',
  analises: 'Análises',
  minhas_analises: 'Minhas Análises',
  solicitacoes_gerais: 'Solicitações Gerais',
  tipos_solicitacoes: 'Tipos de Solicitações',
  transferencia_externa: 'Transferência Externa',
  aproveitamento_estudo: 'Aproveitamento de Estudo',
  troca_curso: 'Troca de Curso',
  student_home: 'Página do Aluno',
  student_external_transfer: 'Transferência Externa',
  student_change_of_major: 'Troca de Curso',
  student_credit_transfer: 'Aproveitamento de Estudos',
  student_my_reviews: 'Minhas Análises',
  expired_token: 'Token expirado'
}

export const ROUTES = {
  SIGN_IN: {
    route: 'entrar',
    label: PATH_LABELS.entrar
  },
  MANAGER_PANEL: {
    route: 'pagina-inicial',
    label: PATH_LABELS.pagina_inicial
  },
  REQUEST_TYPES_EXTERNAL_TRANSFER: {
    route: 'pagina-inicial/transferencia-externa/:id',
    label: PATH_LABELS.tipos_solicitacoes
  },
  REQUEST_TYPES_CREDIT_TRANSFER: {
    route: 'pagina-inicial/aproveitamento-estudo/:id',
    label: PATH_LABELS.tipos_solicitacoes
  },
  REQUEST_TYPES_CHANGE_OF_MAJOR: {
    route: 'pagina-inicial/troca-curso/:id',
    label: PATH_LABELS.tipos_solicitacoes
  },
  MY_REVIEWS: {
    route: 'minhas-analises',
    label: PATH_LABELS.minhas_analises
  },
  MY_REVIEWS_GENERAL_REVIEWS: {
    route: 'minhas-analises/solicitacoes-gerais',
    label: PATH_LABELS.solicitacoes_gerais
  },
  MY_REVIEWS_EXTERNAL_TRANSFER: {
    route: 'minhas-analises/transferencia-externa',
    label: PATH_LABELS.transferencia_externa
  },
  REVIEW_TYPES_EXTERNAL_TRANSFER: {
    route: 'minhas-analises/transferencia-externa/:id',
    label: PATH_LABELS.transferencia_externa
  },
  REVIEW_TYPES_CHANGE_OF_MAJOR: {
    route: 'minhas-analises/troca-curso/:id',
    label: PATH_LABELS.troca_curso
  },
  REVIEW_TYPES_CREDIT_TRANSFER: {
    route: 'minhas-analises/aproveitamento-estudo/:id',
    label: PATH_LABELS.aproveitamento_estudo
  },
  MY_REVIEWS_CREDIT_TRANSFER: {
    route: 'minhas-analises/aproveitamento-estudo',
    label: PATH_LABELS.aproveitamento_estudo
  },
  MY_REVIEWS_CHANGE_OF_MAJOR: {
    route: 'minhas-analises/troca-curso',
    label: PATH_LABELS.troca_curso
  },
  GENERAL_REQUESTS: {
    route: 'pagina-inicial/solicitacoes-gerais',
    label: PATH_LABELS.solicitacoes_gerais
  },
  EXTERNAL_TRANSFER: {
    route: 'pagina-inicial/transferencia-externa',
    label: PATH_LABELS.transferencia_externa
  },
  CREDIT_TRANSFER: {
    route: 'pagina-inicial/aproveitamento-estudo',
    label: PATH_LABELS.aproveitamento_estudo
  },
  CHANGE_OF_MAJOR: {
    route: 'pagina-inicial/troca-curso',
    label: PATH_LABELS.troca_curso
  },
  STUDENT_HOME: {
    route: 'pagina-inicial-aluno',
    label: PATH_LABELS.student_home
  },
  STUDENT_EXTERNAL_TRANSFER: {
    route: 'pagina-inicial-aluno/transferencia-externa',
    label: PATH_LABELS.student_external_transfer
  },
  STUDENT_CHANGE_OF_MAJOR: {
    route: 'pagina-inicial-aluno/troca-curso',
    label: PATH_LABELS.student_change_of_major
  },
  STUDENT_CREDIT_TRANSFER: {
    route: 'pagina-inicial-aluno/aproveitamento-estudos',
    label: PATH_LABELS.student_credit_transfer
  },
  STUDENT_MY_REVIEWS: {
    route: 'pagina-inicial-aluno/:id',
    label: PATH_LABELS.student_my_reviews
  },
  STUDENT_AUTH: {
    route: 'auth/student/:token',
    label: ''
  },
  EXPIRED_TOKEN: {
    route: 'auth/expired-token',
    label: PATH_LABELS.expired_token
  }
}
